import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";

export function NotFoundPage(): JSX.Element {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 bg-background text-center">
      <div className="text-5xl font-bold text-primary">404</div>
      <div className="text-lg text-muted-foreground">That page doesn't exist.</div>
      <Button asChild>
        <Link to="/dashboard">Back to dashboard</Link>
      </Button>
    </div>
  );
}
